interface IExtraField {
    type: string;
    name: string;
    defaultValue?: string;
    data?: any[];
}

interface IEmailMap {
    [key: string]:
        | {
              type: 'klaviyo';
              list_id: string;
              source: string;
              consent_form_id: string;
              popupBtnLink: string;
          }
        | {
              type: 'mailchimp';
              action: string;
              extraFields?: IExtraField[];
              popupBtnLink?: string;
          }
        | {
              type: 'emarsys';
              source: string;
          };
}

export const emailShareMap: IEmailMap = {
    eu: {
        type: 'emarsys',
        source: 'REFERRAL_ADVOCATED_SUB',
    },
    uk: {
        type: 'emarsys',
        source: 'REFERRAL_ADVOCATED_SUB',
    },
    de: {
        type: 'emarsys',
        source: 'REFERRAL_ADVOCATED_SUB',
    },
    fr: {
        type: 'emarsys',
        source: 'REFERRAL_ADVOCATED_SUB',
    },
    it: {
        type: 'emarsys',
        source: 'REFERRAL_ADVOCATED_SUB',
    },
    es: {
        type: 'emarsys',
        source: 'REFERRAL_ADVOCATED_SUB',
    },
    za: {
        type: 'emarsys',
        source: 'REFERRAL_ADVOCATED_SUB',
    },
    au: {
        type: 'emarsys',
        source: 'REFERRAL_ADVOCATED_SUB',
    },
    kr: {
        type: 'mailchimp',
        action: 'https://ecoflow.us14.list-manage.com/subscribe/post?u=60f049f50357a87af9abdbbb2&amp;id=bc6106a237&amp;f_id=002155e0f0',
    },
};

export const emailReceiveMap: IEmailMap = {
    eu: {
        type: 'emarsys',
        source: 'REFERRAL_FRIENDS_SUB',
    },
    uk: {
        type: 'emarsys',
        source: 'REFERRAL_FRIENDS_SUB',
    },
    de: {
        type: 'emarsys',
        source: 'REFERRAL_FRIENDS_SUB',
    },
    fr: {
        type: 'emarsys',
        source: 'REFERRAL_FRIENDS_SUB',
    },
    it: {
        type: 'emarsys',
        source: 'REFERRAL_FRIENDS_SUB',
    },
    es: {
        type: 'emarsys',
        source: 'REFERRAL_FRIENDS_SUB',
    },
    za: {
        type: 'emarsys',
        source: 'REFERRAL_FRIENDS_SUB',
    },
    au: {
        type: 'emarsys',
        source: 'REFERRAL_FRIENDS_SUB',
    },
    kr: {
        type: 'mailchimp',
        action: 'https://ecoflow.us14.list-manage.com/subscribe/post?u=60f049f50357a87af9abdbbb2&amp;id=bc6106a237&amp;f_id=002155e0f0',
    },
};

export const CommunityUrl: Record<string, string> = {
    de: 'https://bit.ly/3Lz4POj',
    fr: 'https://bit.ly/3t8e9Te',
    uk: 'https://bit.ly/3LsWa04',
    it: 'https://bit.ly/3rrvwxF',
    eu: 'https://bit.ly/3sXhlRg',
    es: 'https://bit.ly/3sXhlRg',
    au: 'https://bit.ly/3uB61et',
    kr: 'https://bit.ly/3N6YfPN',
    ca: 'https://bit.ly/3uGBYlH',
    us: 'https://bit.ly/3uGBYlH',
    za: 'https://bit.ly/3txWPY5',
    jp: 'https://lin.ee/jilsz6h',
};
